import { render, staticRenderFns } from "./DataFieldQueriesCountIcon.vue?vue&type=template&id=1b401bc3&scoped=true"
import script from "./DataFieldQueriesCountIcon.vue?vue&type=script&lang=ts"
export * from "./DataFieldQueriesCountIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b401bc3",
  null
  
)

export default component.exports